// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

const WHITE = "#FFFFFF";
const BLACK = "#000000";

const colors: Record<string, string> = {
  primary27: "#7829c0",
  "primary27-lighten": "#ac52ff",
  "primary27-darken": "#501B82",
  "on-primary27": WHITE,
  primary28: "#3FA2CC",
  "primary28-lighten": "#82d7fd",
  "primary28-darken": "#2A6B87",
  "on-primary28": WHITE,
  primary29: "#E67D37",
  "primary29-lighten": "#ffa365",
  "primary29-darken": "#AB5A24",
  "on-primary29": WHITE,
  primary30: "#00C7C7",
  "primary30-lighten": "#8effff",
  "primary30-darken": "#008C8C",
  "on-primary30": WHITE,
  primary31: "#f0fc03",
  "primary31-lighten": "#f7ff69",
  "primary31-darken": "#a8b000",
  "on-primary31": BLACK,
  primary32: "#ff40ce",
  "primary32-lighten": "#ff60d9",
  "primary32-darken": "#cc00a0",
  "on-primary32": WHITE,
  primary33: "#a3e615",
  "primary33-lighten": "#c7ff54",
  "primary33-darken": "#94b40b",
  "on-primary33": WHITE,
  primary34: "#5b28bf",
  "primary34-lighten": "#8b52ff",
  "primary34-darken": "#3e1b82",
  "on-primary34": WHITE,

  noPlay: "#FFFFFF",
  failed: "#C0C0C0",
  assistClear: "#9595FF",
  easyClear: "#98FB98",
  clear: "#AFEEEE",
  hardClear: "#FF6347",
  exHardClear: "#FFD900",
  fullcomboClear: "#FF8C00",

  aaa: "#f9dfe0",
  aa: "#f9ede0",
  a: "#dff9fa",
  b: "#dff9e0",
  c: "#dff9e0",
  d: "#dff9e0",
  e: "#dff9e0",
  f: "#dff9e0",
  noScore: "#dff9e0",

  leggendaria: "#a200d6",
  another: "#d50001",
  hyper: "#d59c01",
  normal: "#0083d6",
  beginner: "#69d501",

  diffRed: "#EE0000",
  diffBlue: "#0000EE",
};

colors.primary = colors.primary34;
colors["primary-lighten-1"] = colors["primary34-lighten"];
colors["primary-darken-1"] = colors["primary34-darken"];
colors["on-primary"] = colors["on-primary34"];

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: colors,
      },
    },
    options: {
      customProperties: true,
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
